<template>
  <div>
    <header class="lmy-header lmy-header-w">
      <i class="iconfont icon-yuyin" @click="routetokPage('/user')"></i>
      返佣订单
    </header>
    <div class="order-list" style="padding-top: 1.2rem">
      <div class="rakeBack-order">
        <div class="order-list-item" v-for="item in list" @click="routeTodetails(item)">
          <div class="item-header">
            <p class="left">{{item.HotelName}}</p>
          </div>
          <div class="item-body">
            <p>入离：{{item.CheckIn | dateShort}}-{{item.CheckOut | dateShort}} | 共{{item.Days}}晚</p>
            <p>{{item.RoomName}} | {{item.RPName}}</p>
            <p>
              总计：<span class="sym">¥</span><span class="num">{{Number(item.TotalAmount).toFixed(2)}}</span>
              返佣：<span class="sym">¥</span><span class="num">{{item.Commission | numberFloat}}</span>
            </p>
          </div>
          <div class="item-footer">
            <div class="left">{{item.BookingOn | dateLong}}</div>
          </div>
        </div>

        <!-- <div class="order-list-item">
          <div class="item-header">
            <p class="left">测试酒店_接口用_仅测试_用_xxx</p>

          </div>
          <div class="item-body">
            <p>入离：11月30日-12月01 | 共1晚</p>
            <p>豪华大床房 | 1人入住不含早</p>
            <p>
              总计：<span class="sym">¥</span><span class="num">299.00</span>
              返佣：<span class="sym">¥</span><span class="num">25</span>
            </p>
          </div>
          <div class="item-footer">
            <div class="left">2019.08.01 16:30:30</div>
          </div>
        </div> -->

      </div>
      <infinite-loading @infinite="initData" ref="infiniteLoading">
				<span slot="no-more">
					没有更多了...
				</span>
        <span slot="no-results">
					您暂时没有任何返佣订单！
				</span>
      </infinite-loading>
    </div>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading';

export default {
  name: 'myOrder',
  components: {
    InfiniteLoading,
  },
  data() {
    return {
      list: [],
      Page: 1,
      PageSize: 10,
      total: 0,
    }
  },
  methods: {
    //条件更新后重置参数和结果
    changeFilter($state) {
      this.Page = 1;
      this.total = 0;
      this.list = [];
      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset');
      });
    },
    initData($state) {
      var that = this;
      if (that.total > 0 && (((that.Page - 1) * that.PageSize) > that.total)) {
        $state.complete();
        return;
      }
      var param = {
        Page: that.Page,
        PageSize: that.PageSize,
      }
      that.postRequest({
        url: that.Api.getCommissionList,
        params: param
      }).then(res => {
        if (res && res.IsSuccess && res.Result.length > 0) {
          that.total = res.Total;
          that.Page += 1;
          that.list = this.list.concat(res.Result);
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/usr/myOrder/cashBack.vue